import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { formValueSelector, change, SubmissionError } from 'redux-form';

import { withAttCurrentCycle } from 'decorators/withCurrentCycle';
import withSubOverdueInvoices from 'decorators/withSubOverdueInvoices';
import { withAttPlans } from 'decorators/withPlans';
import { upgradePurchaseAttPlan } from 'actions/purchases';
import {
  getIncludedInGroups,
  getIsAdmin,
  getSubmitSucceeded,
  getSubmitStatus,
  getAttUpgradePurchaseId,
  getLoggedInUser,
} from 'reducers';
import UpgradePlanModal, { transformValues } from './UpgradePlanModal';
import {
  BUSINESS,
  BUSINESS_ADMIN,
  RESELLER,
  RESOLD_USER,
} from 'permissions/userGroups';

const isSuitableForSplittedForm = (user) =>
  ![BUSINESS, RESELLER, RESOLD_USER].includes(user.acl_group_name);
const shouldSetOverdue = (loggedInUser) =>
  ![BUSINESS, BUSINESS_ADMIN, RESELLER].includes(loggedInUser.acl_group_name);

const mapStateToProps = (state, { subId, user }) => {
  const selector = formValueSelector('upgradeInvoice');
  const loggedInUser = getLoggedInUser(state);
  const showSplittedForm =
    user &&
    loggedInUser &&
    isSuitableForSplittedForm(user) &&
    isSuitableForSplittedForm(loggedInUser);
  return {
    planName: selector(state, 'plan_name'),
    redirectUrl: `/att/subscriptions/${subId}/view`,
    isAdminOrManagerOrBillingOrReseller: getIncludedInGroups(state, [
      'ADMIN',
      'MANAGER',
      'BILLING',
      'RESELLER',
    ]),
    isAdmin: getIsAdmin(state),
    submitSucceeded: getSubmitSucceeded(state, 'upgradeInvoice'),
    saveStatus: getSubmitStatus(state, 'upgradeInvoice'),
    upgradePurchaseId: getAttUpgradePurchaseId(state),
    isAtt: true,
    showSplittedForm,
    loggedInUser,
  };
};

const mapDispatchToProps = (dispatch, { subId, plans, user, ...props }) => ({
  changeField: (...values) => dispatch(change(...values)),
  _onSubmit: (values, loggedInUser) => {
    const showSplittedForm =
      user &&
      loggedInUser &&
      isSuitableForSplittedForm(user) &&
      isSuitableForSplittedForm(loggedInUser);

    if (showSplittedForm) {
      let errors = {};
      if (!values.plan_name) {
        errors.plan_name = 'Required';
      }
      if (!values.plan_price) {
        errors.plan_price = 'Required';
      }

      if (!values.plan_name || !values.plan_price) {
        throw new SubmissionError(errors);
      }

      const transformedValues = transformValues(plans, values);
      return dispatch(
        upgradePurchaseAttPlan({
          att_plan_id: transformedValues.plan,
          att_subscription_id: subId,
          is_upgrade: true,
          is_upcoming: transformedValues.is_upcoming || false,
          set_overdue: shouldSetOverdue(loggedInUser),
        }),
      );
    } else {
      if (!values.plan) {
        throw new SubmissionError({
          plan: 'Required',
        });
      }

      return dispatch(
        upgradePurchaseAttPlan({
          att_plan_id: values.plan,
          att_subscription_id: subId,
          is_upcoming: values.is_upcoming || false,
          is_upgrade: true,
          set_overdue: shouldSetOverdue(loggedInUser),
        }),
      );
    }
  },
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    onSubmit: (values) =>
      dispatchProps._onSubmit(values, stateProps.loggedInUser),
  };
};

const AttUpgradePlanModal = compose(
  withAttCurrentCycle,
  withSubOverdueInvoices,
  withAttPlans,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
)(UpgradePlanModal);

const OpenModalController = (props) => {
  if (props.isOpen) {
    return <AttUpgradePlanModal {...props} />;
  } else {
    return null;
  }
};

export default OpenModalController;
